import { Box } from '@mui/material';
import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { DateFormatPreset, formatDate } from '@procureai/ui-mui';
import { Union } from 'ts-toolbelt';

import { NULLISH_CELL_VALUE } from '../../DataGridCustom.types';
import { StatusUnion } from '~/common/types';
import { colorFromStatus } from '~/util/conversion';
import { isString } from '~/util/string';

type DateValue = Date | string | undefined | null;

export type DateRangeCellValue = Union.Nullable<{ from: DateValue; to: DateValue }>;

const formatDateTwoDigit = formatDate(DateFormatPreset.TWO_DIGIT);

const getDate = (value: DateValue) => {
  return isString(value) ? new Date(value) : value;
};

export interface DateRangeCellProps<R extends GridValidRowModel = any> {
  value: DateRangeCellValue;
  row?: R;
  status?: Union.Nullable<StatusUnion>;
}

export const DateRangeCell = <R extends GridValidRowModel = any>({ value, status }: DateRangeCellProps<R>) => {
  if (value) {
    const statusColor = status ? colorFromStatus(status) : undefined;
    const from = getDate(value.from);
    const to = getDate(value.to);
    const equals = from?.getTime() === to?.getTime();

    const output: Date[] = [];
    if (from) {
      output.push(from);
    }
    if (to && !equals) {
      output.push(to);
    }

    if (output.length) {
      return (
        <Box
          component="span"
          sx={{
            color: statusColor && `${statusColor}.main`,
          }}
        >
          {output.map(formatDateTwoDigit).join(' - ')}
        </Box>
      );
    }
  }
  return <>{NULLISH_CELL_VALUE}</>;
};
